module.exports = __webpack_public_path__ + "img/15.9a8b41cf.jpg";